import PropTypes from "prop-types";
import React, { useEffect, useMemo, useState } from "react";
import { Popover, Collapse, Checkbox } from 'antd';
import { RightOutlined } from '@ant-design/icons';
import { fetchCategoryTree } from "../../redux/actions/categoryActions";
import { useDispatch } from "react-redux";
import { fetchBrands, searchProduct } from "../../redux/actions/productActions";
import { productSearchLocal, setSearchTagKeys } from "../../pages/constant/Constants";
import { useHistory } from "react-router-dom";
import { store } from "../..";
import { useMainUIContext } from "../../UIContext";
import New from "./../../assets/images/new-tag.gif";



const ShopCategories = ({ setSidebarFilter, selectedBrands, setSelectedBrands, setVisible, categories, loading, filters, setFilter, formRef, filterKeyword, brandTotalCount, onDescriptionChange, selectedMainCategory, setSelectedMainCategory, searchTag,setSearchTag, 
  setScrollToTop }) => {
  const defaultNumberOfList = 28;
  const [page_size, setPageSize] = useState(defaultNumberOfList);
  const [brandPageSize, setBrandPageSize] = useState(defaultNumberOfList);
  const dispatch = useDispatch();
  const [expandedKeys, setExpandedKeys] = useState([]);
  const [checked, setChecked] = useState([]);
  const [autoExpandParent, setAutoExpandParent] = useState();
  const history = useHistory();
  const { Panel } = Collapse;

  const onExpand = (expandedKeys) => {
    setExpandedKeys(expandedKeys);
    setAutoExpandParent(false);
  };

  const mainUIContext = useMainUIContext();
  const mainUIProps = useMemo(() => {
    return {
      searchKey: mainUIContext.searchKey,
      setSearchKey: mainUIContext.setSearchKey
    };
  }, [mainUIContext]);
  const { searchKey, setSearchKey } = mainUIProps;
  const notFound = ((filterKeyword === 'Brands' || filterKeyword === 'Categories') && <div>Not Found</div>);


  const capitalizeWords = (str) => {
    if (!str) return "";
    return str
      .toLowerCase()
      .split(" ")
      .map((word) => word.charAt(0).toUpperCase() + word.substring(1))
      .join(" ");
  };

  const formatCategories = (categories) => {
    return categories?.map((category) => ({
      ...category,
      name: capitalizeWords(category.name),
      children: category.children ? formatCategories(category.children) : [],
    }));
  };
  const finalCategories = formatCategories(categories) || [];
  const productSearchLocal = JSON.parse(localStorage.getItem("shop_search_filters") || '{}');

  const handleKeyPress = (category, main_cat, isChecked) => {
    try {
      setScrollToTop(true);
    } catch (err) {
    }
    setSelectedMainCategory && setSelectedMainCategory(main_cat);
    
    if (filters) {
        filters.searchKeyForShopPage = "";
    }
    
    localStorage.setItem("pageNumberPreserve", 1);
    setSearchKey("");

    const searchFilters = {
        ...filters,
        page: 1,
        ...(filterKeyword === "OtherFilters" && {
            is_featured: (category === "is_featured" && isChecked) ? 1 : null,
            is_hot_seller: (category === "is_hot_seller" && isChecked) ? 1 : null,
            is_new_arrival: (category === "is_new_arrival" && isChecked) ? 1 : null,
        }),
        ...(filterKeyword === "Brands"
            ? { brand_ids: selectedBrands }
            : (filterKeyword === "Categories"
                ? { category_ids: category.id }
                : {})),
    };

    const urlParts = history.location.pathname.split("/shop/");
    const currentSearch = new URLSearchParams(history.location.search);
    let currentPath = urlParts[1]?.split("?")[0] || "";

    if (filterKeyword === "Categories") {
      localStorage.setItem("parentCategory", main_cat);
        const categorySlug = category.slug || category;
        currentPath = categorySlug;
        setFilter(prev => ({
            ...prev,
            brand_ids: [],
        }));
        setSearchTag({category_ids: category.id,})
        currentSearch.delete("filter_brand");
        currentSearch.delete("search");
        localStorage.setItem("brandsPreserve", "");
        if (productSearchLocal && productSearchLocal.search_filter) {
            productSearchLocal.search_filter = { ...searchFilters };
        }
        localStorage.setItem("shop_search_filters", JSON.stringify(productSearchLocal));
        const newSearchParams = currentSearch.toString();
        history.push(`/shop/${currentPath}${newSearchParams ? `?${newSearchParams}` : ""}`);
        setSelectedBrands("");
    }

    if (filterKeyword === "Brands") {
      let prevBrandSlugs = currentSearch.get("filter_brand") ? currentSearch.get("filter_brand").split(",") : [];
      let prevBrandIds = prevBrandSlugs
          .map(slug => categories.find(cat => cat.slug === slug)?.id)
          .filter(Boolean);
      let updatedBrandIds, updatedBrandSlugs;
      if (isChecked) {
          updatedBrandIds = [...new Set([...prevBrandIds, category.id])];
          updatedBrandSlugs = [...new Set([...prevBrandSlugs, category.slug])];
      } else {
          updatedBrandIds = prevBrandIds.filter(id => id !== category.id);
          updatedBrandSlugs = prevBrandSlugs.filter(slug => slug !== category.slug);
      }
      setSelectedBrands(updatedBrandIds);
      localStorage.setItem("brandsPreserve", updatedBrandIds.join(","));
      searchFilters.brand_ids = updatedBrandIds;
      setFilter(prev => ({
          ...prev,
          brand_ids: updatedBrandIds.join(","),
      }));
      if (updatedBrandSlugs.length) {
          currentSearch.set("filter_brand", updatedBrandSlugs.join(","));
      } else {
          currentSearch.delete("filter_brand");
      }
  }

    if (filterKeyword === "OtherFilters") {
        const otParam = category === "is_featured" && isChecked
            ? "is_featured"
            : category === "is_hot_seller" && isChecked
                ? "is_hot_seller"
                : category === "is_new_arrival" && isChecked
                    ? "is_new_arrival"
                    : "";
        if (otParam) {
            currentSearch.set("filter_other", otParam);
        } else {
            currentSearch.delete("filter_other");
        }
    }
    const queryString = decodeURIComponent(currentSearch.toString());
    const updatedQueryString = queryString.replace(/search=[^&]*&?|&search=[^&]*/g, "").replace(/^&|&$/, "");
    const finalUrl = `/shop/${currentPath}${updatedQueryString ? `?${updatedQueryString}` : ""}`;
    history.push(finalUrl);

    if (productSearchLocal) {
        productSearchLocal.search_filter = { ...searchFilters };
        localStorage.setItem("shop_search_filters", JSON.stringify(productSearchLocal));
    }
    
    setFilter(searchFilters);
    try {
        if (window.innerWidth > 850 && filterKeyword === "Categories") {
          onDescriptionChange(category?.description);
        }
    } catch (err) {}
};

  const SubMenuItems = ({ children, parent_id }) => {
    if (!children || children.length === 0) {
      return null;
    }
    return (
      <div style={{ marginLeft: '10px', color: "#808080", }}>
        {children.map((child) => (
          <div
            key={child.id}
            onClick={() => handleKeyPress(child, parent_id)}
            className={`red-hover-margin category-name category-item-one ${filters?.category_ids === child.id ? 'active-category' : 'red-hover' || selectedMainCategory == child.id || child.id == localStorage.getItem("parentCategory")}`}
          >
            - {child.name}
          </div>
        ))}
      </div>
    );
  };

  const renderPopoverContent = (children, parent_id) => {
    return (
      <div style={{ display: 'flex', flexWrap: 'wrap', flexDirection: 'row', fontSize: '16px' }}>
        {children.map((child) => (
          <div style={{ width: '25%' }}>
            <div
              key={child.id}
              onClick={() => handleKeyPress(child, parent_id)} 
              className={`category-item-one  ${filters?.category_ids === child.id ? 'active-category' : 'red-hover'}`}
            >
              {child.name}
            </div>
            <SubMenuItems children={child.children} parent_id={parent_id} />
          </div>
        ))}
      </div>
    );
  };
  const renderPopoverContentMobile = (children) => {
    return (
      <div style={{ display: 'flex', flexWrap: 'wrap', flexDirection: 'row', fontSize: '16px' }}>
        {children.map((child) => (
          <>
            <Collapse bordered={false}>
              <Panel
                showArrow={false}
                key={child.id}
                header={
                  <div
                    className={`category-item category-name ${(filters?.category_ids === child.id || child.id === localStorage.getItem("parentCategory")) ? 'active-category' : 'red-hover'}`}
                  >
                    <p className="category-name" onClick={() => handleKeyPress(child)}> {child.name} </p>
                    {child.children.length > 0 && <RightOutlined style={{ color: "black" }} />}
                  </div>
                }
              >
                <div style={{ width: '100%' }}>
                  <SubMenuItems children={child.children} />
                </div>
              </Panel>
            </Collapse>

          </>
        ))}
      </div>
    );
  };

  return (
    <>
      {filterKeyword === 'OtherFilters' && (
        <div className="explore-filters">
          <div className="explore-filters-item">
            <div style={{display:"flex", flexDirection:"row"}}>
              <span>New Arrivals</span>
              <img className="new-badge" src={New} />
            </div>
            <Checkbox
              checked={filters?.is_new_arrival}
              onChange={(e) => handleKeyPress('is_new_arrival', null, e.target.checked)}
            />
          </div>
          <div className="explore-filters-item">
            <span>Featured Products</span>
            <Checkbox
              checked={filters?.is_featured}
              onChange={(e) => handleKeyPress('is_featured', null, e.target.checked)}
            />
          </div>
          <div className="explore-filters-item">
            <span>Hot Seller Products</span>
            <Checkbox
              checked={filters?.is_hot_seller}
              onChange={(e) => {
                handleKeyPress('is_hot_seller', null, e.target.checked);
              }
              }
            />
          </div>
        </div>
      )}

      <div className="sidebar-widget desktop-hide">
      <div className={filterKeyword === 'Brands' ? "sidebar-widget-list scroll-on-brand" : "sidebar-widget-list"}>
      {finalCategories.length > 0 ? (
            finalCategories.map((category) => (
              category.children && category.children.length > 0 ? (
                <Collapse bordered={false} >
                  <Panel
                    key={category.id}
                    showArrow={false}
                    header={
                      <div
                        className={`category-name category-panel ${filters?.category_ids === category.id ? 'active-category' : 'red-hover'}`}
                      >
                        <p className="category-name" onClick={() => handleKeyPress(category)} > {category.name} </p>
                        <RightOutlined style={{ color: "black" }} />
                      </div>
                    }
                  >
                    {category.children && category.children.length > 0 ? (
                      renderPopoverContentMobile(
                        filterKeyword === "Brands"
                          ? category.children
                          : category.children.slice(0, page_size),
                        category.id
                      )
                    ) : null}
                  </Panel>
                </Collapse>
              ) : (
                filterKeyword === 'Categories' ? (
                  <div
                    key={category.id}
                    className={`category-name ${(
                      (filterKeyword === 'Categories' && filters?.category_ids === category.id)
                    ) ? 'active-category' : 'red-hover'}`}
                    onClick={() => handleKeyPress(checked ? category : null)}
                  >
                    {category.name}
                  </div>
                ) : (
                  <div style={{ display: "flex", flexDirection: "column", lineHeight: "30px" }}>
                    <Checkbox
                      key={category.id}
                        checked={
                            selectedBrands.includes(category.id) || 
                            (localStorage.getItem("brandsPreserve") && 
                            localStorage.getItem("brandsPreserve").split(",").includes(String(category.id)))
                        }
                        onChange={(e) => handleKeyPress(category, null, e.target.checked)}
                    >
                      {category.name}
                    </Checkbox>
                  </div>
                )
              )
            ))
          ) : (
            notFound
          )
          }
        </div>
      </div>
      <div className="sidebar-widget mobile-hide ">
      <div className={filterKeyword === 'Brands' ? "sidebar-widget-list scroll-on-brand" : "sidebar-widget-list"}>
      {finalCategories.length > 0 ? (
            finalCategories.map((category) => (
              category.children && category.children.length > 0 ? (
                <Popover
                  // open={true}
                  key={category.id}
                  content={renderPopoverContent(
                    filterKeyword === "Brands"
                      ? category.children
                      : category.children.slice(0, page_size),
                    category.id
                  )}
                  trigger="hover"
                  placement="right"
                  overlayStyle={{ width: '70%', height: "40%", top: "250px" }}
                >
                  <div onClick={() => handleKeyPress(category)} className={`category-name category-pop ${(
                    (filters?.category_ids === category.id) ||
                    category.id == localStorage.getItem("parentCategory") 
                  ) ? 'active-category' : 'red-hover'}`}>
                    {category.name}
                    <RightOutlined />
                  </div>
                </Popover>
              ) : (
                filterKeyword === 'Categories' ? (
                  <div
                    key={category.id}
                    className={`category-name ${(
                      (filterKeyword === 'Categories' && filters?.category_ids === category.id)
                    ) ? 'active-category' : 'red-hover'}`}
                    onClick={() => handleKeyPress(checked ? category : null)}
                  >
                    {category.name}
                  </div>
                ) : (
                  <div style={{ display: "flex", flexDirection: "column", lineHeight: "30px" }}>
                    <Checkbox
                        key={category.id}
                        checked={
                            selectedBrands.includes(category.id) || 
                            (localStorage.getItem("brandsPreserve") && 
                            localStorage.getItem("brandsPreserve").split(",").includes(String(category.id)))
                        }
                        onChange={(e) => handleKeyPress(category, null, e.target.checked)}
                    >
                        {category.name}
                    </Checkbox>

                  </div>
                )
              )
            ))
          ) : (
            notFound
          )
          }
        </div>
      </div>
    </>
  );
};

ShopCategories.propTypes = {
  categories: PropTypes.array,
  setFilter: PropTypes.func,
  formRef: PropTypes.object,
  filterKeyword: PropTypes.string,
};

export default ShopCategories;
